<template>
  <div class="newsletter py25 px15 bg-cl-transparent" v-show="!isSubscribed">
    <div class="container">
      <div class="newsletter-content m0 row middle-sm start-md">
        <div class="col-md-8 col-xs-12">
          <cms-block-chunk class="h3 cl-dark weight-400 m0" :identifier="`c_BOX_NEWSLETTER`" />
        </div>
        <div class="newsletter-button col-md-4 col-xs-12 end-md">
          <button-outline
            @click.native="showNewsletterPopup"
            color="cl-dark dark"
            data-testid="openNewsletterButton"
          >
            {{ $t('Subscribe') }}
          </button-outline>
        </div>
      </div>
    </div>
    <newsletter-popup v-if="loadNewsletterPopup" />
  </div>
</template>

<script>
import SubscriptionStatus from '@vue-storefront/core/modules/newsletter/mixins/SubscriptionStatus'
import ButtonOutline from 'theme/components/theme/ButtonOutline'
import { mapState } from 'vuex'
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk'
const NewsletterPopup = () => import(/* webpackChunkName: "vsf-newsletter-modal" */ 'theme/components/core/NewsletterPopup.vue')

export default {
  name: 'Newsletter',
  mixins: [SubscriptionStatus],
  data () {
    return {
      loadNewsletterPopup: false
    }
  },
  computed: {
    ...mapState({
      isOpen: state => state.ui.newsletterPopup
    })
  },
  methods: {
    showNewsletterPopup () {
      this.loadNewsletterPopup = true
      this.$bus.$emit('modal-show', 'modal-newsletter')
    }
  },
  components: {
    ButtonOutline,
    NewsletterPopup,
    CmsBlockChunk
  }
}
</script>

<style scoped>
  .newsletter {
    margin: 0 40px;
  }
  .h3 h2 {
    font-size: 24px;
  }
  @media (min-width: 768px) and (max-width: 1200px){
    .button-outline{
      min-width: 100%;
    }
  }
  @media (max-width: 768px) {
    .newsletter {
      margin: 0 10px;
      padding: 25px 0px !important;
      min-height: 202px;
    }
    .h3 {
      font-size: 18px;
      text-align: center;
    }
    .newsletter-button {
      padding-top: 25px;
      text-align: center;
    }
  }
</style>
